<template>
  <div class="py-6 px-8">
    <h-header>
      <template v-slot:actions>
        <v-btn
          @click="openCreateAnnouncementModal"
          color="primary"
          elevation="0"
        >
          <v-icon left>mdi-plus</v-icon>
          <span class="d-none d-md-flex body-2">
            {{ $t(`create.label.announcement`) }}
          </span>
        </v-btn>
      </template>
    </h-header>

    <AdminAnnouncementListFilters />

    <v-card outlined>
      <v-data-table
        @dblclick:row="showAnnouncementRow"
        :no-data-text="$t('appointment.table.noData')"
        :loading-text="$t('appointment.table.loading')"
        :items-per-page="itemsPerPage"
        :items="announcements"
        :loading="isLoading"
        :headers="headers"
        mobile-breakpoint="20"
        class="clickable"
        hide-default-footer
        disable-sort
      >
        <template v-slot:[`item.created_at`]="{ item }">
          <span class="body-2">
            {{ formatDate(item.created_at) }}
          </span>
        </template>
        <template v-slot:[`item.release_date`]="{ item }">
          <span v-if="item.release_date" class="body-2">
            {{ formatDate(item.release_date) }}
          </span>
          <span v-else class="body-2">
            {{ $t('announcement.label.list.releaseDateImmediately') }}
          </span>
        </template>
        <template v-slot:[`item.type`]="{ item }">
          <span class="body-2">
            {{ $t(`announcement.label.list.announcementTypes.${item.type}`) }}
          </span>
        </template>
        <template v-slot:[`item.title`]="{ item }">
          <span class="body-2">
            {{ item.title }}
          </span>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <AnnouncementListRowMenu
            :announcementId="item.id"
            @showAnnouncement="showAnnouncement"
            @duplicateAnnouncement="duplicateAnnouncement"
            @confirmDeleteAnnouncement="confirmDeleteAnnouncement"
          />
        </template>
      </v-data-table>
    </v-card>
    <h-pagination :fetch="fetchAnnouncements" />

    <RightDrawer :moreInfo="false">
      <AnnouncementSummary />
    </RightDrawer>

    <AnnouncementCreate ref="announcementCreate" />
    <ModalAnnouncementConfirmDelete ref="modalAnnouncementDelete" />
  </div>
</template>

<script>
import AdminAnnouncementListFilters from '@/components/announcement/AdminAnnouncementListFilters'
import ModalAnnouncementConfirmDelete from '@/components/announcement/ModalAnnouncementConfirmDelete'
import AnnouncementListRowMenu from '@/components/announcement/AnnouncementListRowMenu'
import AnnouncementSummary from '@/components/announcement/AnnouncementSummary'
import AnnouncementCreate from '@/components/announcement/AnnouncementCreate'
import RightDrawer from '@/components/app/RightDrawer'

import { mapGetters, mapActions, mapMutations } from 'vuex'
import { announcementHeaders } from './listHeaders/announcementHeaders'
import { catalogDate } from '@/util/catalog'

export default {
  name: 'AdminAnnouncementList',
  components: {
    ModalAnnouncementConfirmDelete,
    AdminAnnouncementListFilters,
    AnnouncementListRowMenu,
    AnnouncementSummary,
    AnnouncementCreate,
    RightDrawer,
  },

  data() {
    return {
      headers: announcementHeaders,
      formatDate: catalogDate,
    }
  },

  computed: {
    ...mapGetters([
      'isLoading',
      'itemsPerPage',
      'announcements',
    ]),
  },

  methods: {
    ...mapMutations(['setIsDrawerOpen', 'openModal']),
    ...mapActions(['fetchAnnouncements', 'fetchAnnouncement']),

    confirmDeleteAnnouncement(id)  {
      this.fetchAnnouncement(id)
      this.openModal('CONFIRM_DELETE_ANNOUNCEMENT')
    },

    showAnnouncement(id) {
      this.setIsDrawerOpen(true)
      this.fetchAnnouncement(id).finally(() => this.$refs.announcementCreate?.resetForm())
    },

    showAnnouncementRow(_, { item }) {
      this.showAnnouncement(item.id)
    },

    duplicateAnnouncement(id) {
      this.$refs.announcementCreate?.resetForm()
      this.$refs.announcementCreate?.$refs.createModal.openCreateModal()
      this.fetchAnnouncement(id)
    },

    openCreateAnnouncementModal() {
      const modal = this.$refs?.announcementCreate
      modal.openModal()
    }
  },

  mounted() {
    this.$nextTick(() => this.fetchAnnouncements())
  },
}
</script>
